import Vue from 'vue'
import Router from 'vue-router'

import FirstPage from '@/components/FirstPage'
import TermsOfService from '@/components/TermsOfService'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import Namespaces from '@/components/Namespaces';
import Quotas from '@/components/Quotas';
import SuperAdminUsers from '@/components/superadmin/Users';
import SuperAdminHealth from '@/components/superadmin/Health';
import GenerateToken from '@/components/GenerateToken';
import Tokens from '@/components/Tokens';
import AddNamespace from '@/components/AddNamespace';
import PageNotFound from '@/components/misc/PageNotFound';
import LoginCallback from '@/components/misc/LoginCallback';
//const OpenAPI = () => import('@/components/OpenAPI')
import OpenAPI from '@/components/OpenAPI';
import AppLogin from '@/components/popup/AppLogin';
import AppCreateToken from '@/components/popup/AppCreateToken';
import AppAutoAuth from '@/components/popup/AppAutoAuth';
const auth = require('./utils/auth')

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    // NON AUTHENTICATED FIRST
    {
      name: 'firstpage',
      path: '/',
      component: FirstPage,
      props: true
    },
    {
      name: 'terms-of-service',
      path: '/terms-of-service',
      component: TermsOfService,
      props: true
    },
    {
      name: 'privacy-policy',
      path: '/privacy-policy',
      component: PrivacyPolicy,
      props: true
    },
    {
      path: '/app-login',
      component: AppLogin,
    },
    {
      name: 'login-callback',
      path: '/login-callback',
      component: LoginCallback,
      props: true
    },
    {
      path: '/openapi',
      component: OpenAPI,
    },

    // AUTHENTICATED BELOW
    {
      path: '/namespaces',
      beforeEnter: auth.requireAuthExpress,
      component: Namespaces,
    },
    {
      path: '/namespaces/new',
      beforeEnter: auth.requireAuthExpress,
      component: AddNamespace,
    },
    {
      path: '/quotas',
      beforeEnter: auth.requireAuthExpress,
      component: Quotas,
    },
    {
      path: '/tokens',
      beforeEnter: auth.requireAuthExpress,
      component: Tokens,
    },
    {
      path: '/tokens/new',
      beforeEnter: auth.requireAuthExpress,
      component: GenerateToken,
    },
    {
      path: '/app-create-token',
      beforeEnter: auth.requireAuthExpress,
      component: AppCreateToken,
    },
    {
      path: '/app-auto-auth',
      beforeEnter: auth.requireAuthExpress,
      component: AppAutoAuth,
    },

    // SUPERADMIN BELOW
    {
      path: '/users',
      beforeEnter: auth.requireSuperAdmin,
      component: SuperAdminUsers,
    },
    {
      path: '/health',
      beforeEnter: auth.requireSuperAdmin,
      component: SuperAdminHealth,
    },

    // CATCH ALL
    {
      path: "*",
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js